Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplaceParam = void 0;
var ReplaceParam = exports.ReplaceParam = function ReplaceParam() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return value.replace('%7B%7Bparam%7D%7D', param).replace('%257B%257Bparam%257D%257D', param).replace('{{param}}', param);
};